import { ExternalRouter } from 'src/lib/external-router';

import Config from '../config';

const { docsUrl } = Config;

export const DocsRouter = new ExternalRouter(docsUrl, {
  Home: '',

  GettingStarted: 'quickstart#:hash',

  // GraphOS
  StudioHome: 'graphos/platform',

  SSOOverview: 'graphos/org/sso/overview',
  SSOMigrationGuide: 'graphos/org/sso/self-service/migration',
  PersonalApiKeys:
    'graphos/platform/access-management/api-keys/personal-api-keys',
  SchemaValidation: 'graphos/delivery/schema-checks',
  SchemaValidationPotentiallyBreakingChanges:
    'graphos/platform/schema-management/checks/reference#potentially-breaking-changes',
  SchemaValidationReferenceTypesOfChanges:
    'graphos/platform/schema-management/checks/reference#types-of-schema-changes',
  SchemaOverridingFlaggedChanges:
    'graphos/platform/schema-management/checks/run#overriding-flagged-changes',
  IntegrateChecksWithGitHub:
    'graphos/platform/schema-management/checks/github-integration',
  LinterRules: `graphos/delivery/linter-rules`,
  LinterConfiguration: `graphos/delivery/schema-linter/#configuring-the-linter`,
  LinterCompositionRules: `graphos/delivery/linter-rules/#composition-hints`,
  CustomChecks: `graphos/platform/schema-management/checks/custom`,

  FederationComposition: `graphos/schema-design/federated-schemas/composition`,
  FederationQuickstart: `federation/quickstart/`,
  FederationUpgrade: `graphos/graphs/updating/`,

  EntepriseFeatures: 'graphos/enterprise/',

  Explorer: 'graphos/explorer',
  ExplorerConnectingWithHash:
    'graphos/explorer/connecting-authenticating#:hash',
  EmbeddedExplorer: 'graphos/explorer/embed-explorer/',
  EmbeddedExplorerOptions: 'graphos/explorer/embed-explorer/#options',
  EmbeddedSandbox: 'graphos/explorer/sandbox/#embedding-sandbox',

  PublicGraphs: 'graphos/graphs/studio-features/#public-variants',

  AuditLogs: 'graphos/org/audit-log',
  UserRoles: 'graphos/org/members/',
  GraphRoles: 'graphos/org/members/#graph-specific-member-roles',
  GraphApiKeyRoles: 'graphos/org/members/#graph-api-key-roles',
  EnterpriseTrialOrgPlan: 'graphos/org/plans/#enterprise-trials',

  ContactDirective:
    '/graphos/platform/graph-management/manage-subgraphs#adding-the-contact-directive',

  SchemaTagging:
    'graphos/platform/graph-management/manage-subgraphs#schema-tagging',
  UsageReporting: 'graphos/metrics',
  UsageReportingWithHash: 'graphos/metrics#:hash',
  ClientAwareness: 'graphos/metrics/client-awareness',
  DatadogIntegration: 'graphos/metrics/datadog-integration',
  EnhancedOperationChecks:
    'graphos/routing/configuration/yaml#enhanced-operation-checks',
  EnhancedSignatureNormalization:
    'graphos/routing/configuration/yaml#enhanced-operation-signature-normalization',
  ErrorConfiguration:
    'graphos/routing/observability/graphos/graphos-reporting#errors',
  ExtendedErrorConfig:
    'graphos/routing/observability/graphos/graphos-reporting#enabling-extended-error-reporting',
  ExtendedReferences:
    'graphos/routing/configuration/yaml#extended-reference-reporting',
  FederatedTracing: 'graphos/routing/v1/observability/federated-trace-data',
  FieldsUsage: 'graphos/metrics/field-usage/',
  FieldUsageMetricsAvailability:
    'graphos/routing/configuration/yaml#extended-reference-reporting',
  NotificationSetup:
    'graphos/platform/insights/notifications/performance-alerts#:hash',
  SchemaProposalNotificationsFormat:
    'graphos/metrics/notifications/schema-proposal-integration/#webhook-format',
  OperationSignatures: 'graphos/metrics/operation-signatures',
  OperationMetrics: 'graphos/metrics/sending-operation-metrics',
  IngestionLimits:
    'graphos/platform/insights/sending-operation-metrics#cardinality-limitation',
  SubgraphMetrics: `graphos/platform/insights/subgraphs`,

  PersistedQueries: 'graphos/operations/persisted-queries',
  SchemaProposals: 'graphos/delivery/schema-proposals',

  // Apollo Server
  UsageReportingPluginWithHash:
    'apollo-server/api/plugin/usage-reporting/#:hash',
  MonitoringAndMetrics: 'apollo-server/monitoring/metrics',
  ApolloServerCaching: 'apollo-server/performance/caching',

  // Federation
  Federation: 'graphos/schema-design/federated-schemas/reference/directives',
  SecureSubgraphs:
    'federation/building-supergraphs/subgraphs-overview#securing-your-subgraphs',
  Entities: '/graphos/schema-design/federated-schemas/entities/intro',
  ManagedFederation: 'federation/managed-federation/setup/',
  FederationQueryPlans: 'federation/query-plans',
  FederationChangelog: 'federation/federation-versions/',
  FederationMetrics: 'graphos/platform/insights',

  // Rover
  RoverCiCdSetup: 'rover/ci-cd/',
  RoverDev: 'rover/commands/dev',
  RoverConfigure: 'rover/configuring',
  RoverGettingStarted: 'rover/getting-started',
  RoverInstallationMethods: 'rover/getting-started#installation-methods',

  // Router
  Router: 'router/',
  DeferSupport: 'router/executing-operations/defer-support/',
  MigratingFromGateway: 'router/migrating-from-gateway/',

  // Resources
  LaunchStages: 'resources/product-launch-stages/',

  RuntimeReleaseLifecycle: 'graphos/resources/runtime-release-lifecycle',

  // SAML
  // TODO(evan-saml-cert): This seems insufficient and confusing. We should work with the docs team to
  // get a better page for this and probably even automatically direct the user to the saml solution for their Idp
  SAMLMetadata: 'graphos/platform/access-management/sso/overview#saml-based',
});
